import AimeosOptionsPlugin from './aimeos-options-plugin'
// import AimeosBasketPlugin from './aimeos-basket-plugin'
import AimeosResourcesPlugin from './aimeos-resources-plugin'

export const getAimeosPlugins = () => [
  AimeosOptionsPlugin,
  AimeosResourcesPlugin,
  // AimeosBasketPlugin,
]
